import { Controller } from "@hotwired/stimulus";
import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';

export class AnnounceCarouselController extends Controller {
  connect() {
    this.swiper = new Swiper(this.element, {
      ...this.defaultOptions,
    });
  }

  disconnect() {
    this.swiper.destroy();
    this.swiper = undefined;
  }

  next() {
    this.swiper.slideNext();
  }

  prev() {
    this.swiper.slidePrev();
  }

  get defaultOptions() {
    return {
      loop: true,
      speed: 500,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      navigation: true,
    }
  }
}

// Registered in customer.js
